import { Trans } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";
import { PlainButton } from "@medoma/components/Button/Button";
import CrossIcon from "@medoma/components/icons/CrossIcon";
import { useLingui } from "@lingui/react/macro";

type AvailableAction =
  | "edit-time"
  | "edit-title"
  | "edit-description"
  | "edit-schedule"
  | "edit-duration"
  | "edit-endDate"
  | "edit-requiredCompetences"
  | "edit-doubleStaffing"
  | "edit-hidden"
  | "edit-measurements"
  | "move"
  | "edit-invoicingCodes"
  | "edit-note";

const editableAttributesDictionary = {
  "edit-time": msg`tiden`,
  "edit-title": msg`namnet`,
  "edit-description": msg`beskrivningen`,
  "edit-schedule": msg`schemat`,
  "edit-duration": msg`tidsåtgången`,
  "edit-endDate": msg`slutdatumet`,
  "edit-requiredCompetences": msg`kompetensbehoven`,
  "edit-doubleStaffing": msg`dubbelbemanning`,
  "edit-hidden": msg`dold för patienten`,
  "edit-measurements": msg`mätvärdena`,
  "edit-invoicingCodes": msg`faktureringskoderna`,
  "edit-note": msg`kommentaren`,
  move: msg`tillhörande besök`,
};

export const EditButton = ({
  label,
  iconStart,
  attribute,
  isEditing,
  toggleIsEditing,
}: {
  label?: string;
  iconStart?: React.ReactNode;
  attribute: AvailableAction;
  isEditing: boolean;
  toggleIsEditing: () => void;
}) => {
  const { t } = useLingui();
  const resolvedLabel = label ?? t`Ändra`;
  const currentlyEdited = t(editableAttributesDictionary[attribute]);
  return (
    <PlainButton
      size="small"
      weight="light"
      onClick={toggleIsEditing}
      aria-label={
        isEditing
          ? t`Avbryt ändring av ${currentlyEdited}`
          : t`Ändra ${currentlyEdited}`
      }
    >
      {isEditing ? (
        <>
          <CrossIcon />
          <Trans>Avbryt</Trans>
        </>
      ) : (
        <>
          {iconStart}
          {resolvedLabel}
        </>
      )}
    </PlainButton>
  );
};
